import { Box, styled, Grid, Typography, Card, TooltipProps, Tooltip, tooltipClasses, Dialog, Tabs, InputAdornment } from '@mui/material';
import ButtonComponent from 'src/components/ButtonComponent';
import Column from 'src/frontend-common/components/Column';
import Row from 'src/frontend-common/components/Row';

export const ExportModalBody = styled(Column)(({ theme }) => ({
  '&>h4': {
    fontSize: 16,
    fontWeight: '500',
    lineHeight: '21.28px',
    marginBottom: theme.spacing(2),
  },
}));

export const CustomInputAdornment = styled(InputAdornment)(({}) => ({
  marginRight: '3px',
  '& p': {
    fontSize: 14,
  },
}));

export const TableWrapper = styled(Box)(() => ({
  overflowY: 'scroll',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
}));

export const CardResponsive = styled(Card)(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    overflowX: 'scroll',
  },
}));

export const CustomRowSlider = styled(Row)(({ theme }) => ({
  alignItems: 'center',
  '& span': {
    width: 100,
    height: 10,
  },
  '& p': {
    marginLeft: theme.spacing(2),
  },
}));

export const DateWrapper = styled(Box)(() => ({
  '&>div': {
    justifyContent: 'flex-start!important',
  },
}));

export const ExportTypeRow = styled(Row)<{ isExport: number }>(({ theme, isExport }) => ({
  justifyContent: 'space-between',
  marginBottom: theme.spacing(7),
  '&>button': {
    all: 'unset',
    border: `2px solid #5359EF14`,
    width: `calc(50% - ${theme.spacing(2)})`,
    borderRadius: '4px',
    padding: theme.spacing(1.5),
    position: 'relative',

    '&>p': {
      position: 'absolute',
      bottom: -32,
      [theme.breakpoints.down('sm')]: {
        bottom: isExport === 1 ? -46 : -32,
      },
      left: 0,
    },
    '&:hover': {
      cursor: 'pointer',
    },
    '&.active': {
      backgroundColor: '#5359EF14',
      '&>div': {
        '&>div': {
          border: `2px solid ${theme.palette.primary.main}`,
        },
      },
    },
    '&>div': {
      justifyContent: 'space-between',
      alignItems: 'center',
      marginLeft: theme.spacing(1),
      '&>div': {
        width: '18px',
        height: '18px',
        borderRadius: '50%',
        backgroundColor: 'transparent',
        border: '2px solid black',
        position: 'relative',
        '&>div': {
          position: 'absolute',
          width: 11,
          height: 11,
          borderRadius: '50%',
          backgroundColor: theme.palette.primary.main,
          top: '20%',
          left: '20%',
        },
      },
    },
    '&:last-of-type': {
      marginLeft: theme.spacing(2),
    },
  },
}));

export const ExportHeaderRow = styled(Row)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between',
  padding: '24px',
  backgroundColor: theme.palette.primary.main,
  alignItems: 'center',
  '&>h4': {
    color: 'white',
    fontSize: 19.2,
    fontWeight: '500',
    lineHeight: '23.71px',
    wordWrap: 'break-word',
  },
  '&>button': {
    color: 'white',
  },
}));

export const ExportButton = styled(ButtonComponent)<{ waiting: string }>(({ waiting, theme }) => ({
  width: waiting === 'true' ? 180 : 100,
  marginBottom: 0,
  marginRight: theme.spacing(2),
  color: theme.palette.text.primary,
}));

export const AntiPaddingBox = styled(Box)(({}) => ({
  '&>div': {
    '&>div': {
      padding: '0px!important',
    },
  },
}));

export const WhiteContainer = styled(Grid)<{ transparentbg?: string }>(({ theme, transparentbg }) => ({
  marginTop: theme.spacing(3),
  padding: theme.spacing(3),
  backgroundColor: transparentbg === 'true' ? 'transparent' : theme.palette.background.paper,
  boxShadow: '0px 1px 1px rgba(100, 116, 139, 0.06), 0px 1px 2px rgba(100, 116, 139, 0.1)',
}));

export const FormContainer = styled('form')(({ theme }) => ({
  '&>div': {
    marginTop: theme.spacing(3),
    width: '100%',
    '&:first-of-type': {
      marginTop: theme.spacing(1),
    },
  },
}));

export const TypographyGridTitle = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));
export const ErrorText = styled(Typography)(({ theme }) => ({
  marginBottom: '0px',
  fontSize: '13px',
  paddingLeft: '24px',
  color: theme.palette.error.main,
  marginTop: '8px',
}));

export const ContainerCard = styled(Card)(({ theme }) => ({
  paddingTop: theme.spacing(1),
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: theme.spacing(1),
  boxShadow: 'none',
}));

export const ActionsWrapper = styled(Row)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0,
  '& button': {
    marginTop: theme.spacing(1),
    fontWeight: 600,
    fontSize: 15,
    '&:first-of-type': {
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.primary.light}`,
      marginRight: theme.spacing(3),
      color: theme.palette.primary.main,
      boxShadow: 'none',
    },
  },
}));

export const PhoneErrorWrapper = styled('div')(() => ({
  fontWeight: 400,
  fontSize: '0.75rem',
  color: '#F44336',
  lineHeight: 1.66,
  letterSpacing: '0.03333em',
  textAlign: 'left',
  marginTop: '3px!important',
  marginRight: 14,
  marginBottom: 0,
  marginLeft: 14,
}));

export const ChipWrapper = styled(Grid)(({ theme }) => ({
  display: 'flex',
  fontSize: '14px !important',
  fontWeight: '400 !important',
  alignContent: 'center',
  justifyContent: 'flex-start',
  alignItems: 'center',
  flexDirection: 'row',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginTop: theme.spacing(2),
  },
  '& h5': {
    fontWeight: 400,
    fontSize: 15,
  },
  '&>div': {
    '&:first-of-type': {
      marginLeft: 0,
      marginTop: theme.spacing(1.2),
      marginBottom: theme.spacing(1.2),
      [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        marginTop: theme.spacing(1.2),
        marginBottom: theme.spacing(1.2),
        marginRight: theme.spacing(1),
      },
    },
    '& span': {
      color: theme.palette.text.secondary,
    },
  },
}));

export const CustomErrorMessage = styled(Typography)(({ theme }) => ({
  color: theme.palette.error.main,
  fontSize: 14,
  fontWeight: 400,
  margin: theme.spacing(2, 3, -1, 3),
}));

export const ButtonWrapper = styled(Row)(({ theme }) => ({
  alignItems: 'center',
  height: 36,
  marginRight: theme.spacing(2),
  '&>p': {
    marginRight: theme.spacing(1),
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    '& svg': {
      fontSize: 16,
      marginLeft: theme.spacing(0.5),
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    height: 'fit-content',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(2),
  },
}));

export const RadioButtonComponent = styled(ButtonComponent)<{
  isactive: 'true' | 'false';
}>(({ theme, isactive }) => ({
  height: theme.spacing(4.5),
  padding: 5,
  borderRadius: 0,
  opacity: isactive === 'true' ? 1 : 0.4,
  border: 'none',
  '&:hover': {
    opacity: 1,
    border: 'none',
    backgroundColor: 'transparent',
  },
}));
export const SubmitGrid = styled(Grid)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  [theme.breakpoints.down('md')]: {
    justifyContent: 'flex-start',
  },
  [theme.breakpoints.down('sm')]: {
    justifyContent: 'flex-start',
    flexDirection: 'column',
  },
}));

export const CustomWidthTooltip = styled(({ className, ...props }: TooltipProps) => <Tooltip {...props} classes={{ popper: className }} />)({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 600,
    padding: 16,
    '& span': {
      fontSize: 14,
      display: 'block',
      marginBottom: 12,
      fontWeight: 400,
      '& strong': {
        fontWeight: 600,
      },
    },
  },
});

export const DialogWrapper = styled(Dialog)(() => ({
  '& .MuiDialog-paper': {
    width: '100%',
  },
}));

export const TabsWrapper = styled(Tabs)<{ fontregular?: 'true' }>(({ theme, fontregular }) => ({
  marginTop: 40,
  borderBottom: '1px solid #E0E0E0',
  button: {
    width: 0,
    fontWeight: fontregular === 'true' ? 400 : 500,
  },
  '&>div': {
    [theme.breakpoints.down('md')]: {
      overflowX: 'scroll!important',
    },
  },
}));

export const LoginBody = styled(Column)(({ theme }) => ({
  width: '100%',
  minHeight: `calc(100vh - ${theme.constants.headerHeight}px)`,
  overflowY: 'scroll',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
}));
